module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Teaching in Fuzhou, China")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch005#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch006#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch007#chapter-1-anglo-chinese-college"
    }
  }, [_vm._v("Chapter 1: Anglo-Chinese College")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#introduction-1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#our-apartment-building"
    }
  }, [_vm._v("1.1: Our Apartment Building")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#college-buildings"
    }
  }, [_vm._v("1.2: College Buildings")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#acc-dining-room"
    }
  }, [_vm._v("1.3: ACC Dining Room")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#college-oval"
    }
  }, [_vm._v("1.4: College Oval")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#other-sporting-facilities"
    }
  }, [_vm._v("1:5: Other Sporting Facilities")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#college-buses"
    }
  }, [_vm._v("1.6: College Buses")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch008#chapter-2-working-at-acc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Working at ACC")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#introduction-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#names",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1: Names")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#individual-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2: Individual Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#wednesdays-in-2003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3: Wednesdays in 2003")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#maria-chen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4: Maria Chen")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#concerts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.5: Concerts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#health-checks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.6: Health Checks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#information",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.7: Information")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch009#chapter-3-acc-middle-school",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: ACC Middle School")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#introduction-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#teaching-junior-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1: Teaching Junior 1")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#acc-reunion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2: ACC Reunion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#an-excursion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3: An Excursion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#number-1-middle-school",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4: Number 1 Middle School")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#recruitment-drive",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5: Recruitment Drive")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch010#chapter-4-english-corner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: English Corner")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#introduction-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#tai-jiang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1: Tai Jiang")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#xinhua-bookstore",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2: Xinhua Bookstore")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#acc-free-talk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3: ACC Free Talk")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chinglish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4: Chinglish")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch011#chapter-5-oracular-riches",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Oracular Riches")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#introduction-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#cctv-cup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1: CCTV Cup")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#i-speak-therefore-i-am",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2: I Speak, Therefore I Am")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#childrens-contest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3: Children’s Contest")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#open-speech-contest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4: Open Speech Contest")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#awards-night",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5: Awards Night")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#class-speeches",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6: Class Speeches")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch012#chapter-6-plays",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Plays")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#introduction-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#sleeping-beauty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1: Sleeping Beauty")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#robyn-hood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2 Robyn Hood")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#conclusion-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch013#chapter-7-extra-curricular-activities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Extra-Curricular Activities")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#introduction-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#friday-13th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1: Friday 13"), _c('sup', [_vm._v("th")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#private-tutoring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2 Private Tutoring")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch014#chapter-8-some-daily-happenings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Some Daily Happenings")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#introduction-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#scenes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.1: Scenes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#our-neighbours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.2: Our Neighbours")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#measures-and-countermeasures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.3: Measures and Countermeasures")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#shopping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.4: Shopping")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#banking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.5: Banking")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#rainy-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.6: Rainy Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#funerals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.7: Funerals")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#entertainment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.8: Entertainment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#a-fashion-parade",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.9: A Fashion Parade")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#exercise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.10: Exercise")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#more-chinglish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.11: More Chinglish")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch015#chapter-9-education",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Education")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#introduction-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#teachers-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.1: Teachers’ Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#new-semesters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2: New Semesters")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#students-participation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3: Students’ Participation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.4: Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#classes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.5: Classes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#english-club",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.6: English Club")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#assessment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.7: Assessment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#my-final-semester",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.8: My Final Semester")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#eastern-and-western-education",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.9: Eastern and Western Education")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch016#chapter-10-religion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Religion")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#introduction-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#underground-churches",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.1: Underground Churches")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#religious-services",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.2 Religious Services")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#holy-week",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.3: Holy Week")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#rosa-mystica",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.4: Rosa Mystica")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#spies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.5: Spies")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#beijing-and-the-vatican",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.6: Beijing and the Vatican")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch017#chapter-11-the-darker-side",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Darker Side")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#introduction-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#stealing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.1: Stealing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#aggression",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.2: Aggression")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#thoughtlessness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.3: Thoughtlessness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#nationalism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.4: Nationalism")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#indifference",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.5: Indifference")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#a-homicide",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.6: A Homicide")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "0px",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#/text/ch018#chapter-12-farewell-to-fuzhou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Farewell to Fuzhou")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#introduction-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#farewell-to-a-family",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.1: Farewell to a Family")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#farewell-to-greg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.2: Farewell to Greg")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#farewell-to-brian",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.3: Farewell to Brian")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#farewell-to-fuzhou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.4: Farewell to Fuzhou")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0